import { gql } from '@apollo/client';
import { BasicRoleResponse, RolesPaginationData } from './types';

export interface RoleCategory {
  id: string;
  group?: string;
  name: string;
}

export interface RoleResponse extends BasicRoleResponse {
  category: RoleCategory;
}

export interface AllRoleResponse {
  allRoles: RolesPaginationData<RoleResponse>;
}

export const GET_ROLES_N_PERMISSIONS = gql`
  query allRoles(
    $pageNumber: Int = 0
    $pageSize: Int = 10
    $search: String = ""
  ) {
    allRoles(pageNumber: $pageNumber, pageSize: $pageSize, search: $search) {
      totalCount
      roles {
        id
        name
        description
        permissions
        category {
          id
          group
          name
        }
      }
    }
  }
`;
